export default {
    data: () => ({
        translations: {
            hello: {
                el: "Καλωσόρισες",
                en: "Hello",
                it: "Ciao"
            },
            cardDescription: {
                el: "Επίλεξε κατάστημα ή επιχείρηση",
                en: "Select store or company.",
                it: "Seleziona il negozio o l'azienda."
            },
            enter: {
                el: "Είσοδος",
                en: "Enter",
                it: "Entrare"
            },
            switchAccount: {
                el: "Αλλαγή Λογαριασμού",
                en: "Switch Account",
                it: "Cambia account"
            },
            createStore: {
                el: "Δημιούργια καταστήματος",
                en: "Create Store",
                it: "Creare negozio"
            },
            createCompany: {
                el: "Δημιούργια Προγράμματος Πιστότητας",
                en: "Create Loyalty",
                it: "Creare fedeltà"
            },
            logout: {
                el: "Aποσύνδεση",
                en: "Logout",
                it: "Logout"
            },
            changeProfileName: {
                el: "Αλλαγή ονόματος προφίλ",
                en: "Change Profile Name",
                it: "Modifica del nome del profilo"
            },
            save: {
                el: "Αποθηκευση",
                en: "Save",
                it: "Risparmiare"
            },
            cancel: { 
                el: 'Ακύρωση', 
                en: 'Cancel', 
                it: 'Cancella' 
            },
            fullName: {
                el: "Ονοματεπώνυμο",
                en: "Full Name",
                it: "Nome e cognome"
            },
        }
    })
};
